/* Bumi Glow — theme.js · ~3kb, no dependencies */
(function () {
  "use strict";

  /* mobile nav */
  var t = document.querySelector("[data-menu-toggle]"),
      d = document.getElementById("mobile-drawer");
  if (t && d) t.addEventListener("click", function () {
    var open = d.classList.toggle("is-open");
    t.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* product gallery */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main]");
    g.querySelectorAll("[data-gallery-thumb]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!main) return;
        main.src = b.dataset.src;
        main.srcset = b.dataset.srcset || "";
        main.alt = b.dataset.alt || main.alt;
        g.querySelectorAll("[data-gallery-thumb]").forEach(function (x) {
          x.setAttribute("aria-current", x === b ? "true" : "false");
        });
      });
    });
  });

  /* quantity stepper */
  document.querySelectorAll("[data-qty]").forEach(function (q) {
    var i = q.querySelector("input");
    q.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        var step = b.dataset.step === "up" ? 1 : -1,
            v = Math.max(1, (parseInt(i.value, 10) || 1) + step);
        i.value = v;
        i.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* variant selection — swaps price, availability, stock and URL */
  document.querySelectorAll("[data-variants]").forEach(function (form) {
    var data;
    try { data = JSON.parse(form.querySelector("[data-variant-json]").textContent); } catch (e) { return; }
    var idField = form.querySelector("[data-variant-id]"),
        priceEl = form.querySelector("[data-price]"),
        btn     = form.querySelector("[data-add]"),
        stockEl = form.querySelector("[data-stock]"),
        low     = parseInt(form.dataset.lowStock || "8", 10),
        money   = form.dataset.moneyFormat || "${{amount}}";

    function fmt(cents) {
      var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return money.replace(/\{\{\s*amount[^}]*\}\}/, n);
    }
    function selected() {
      return Array.prototype.map.call(form.querySelectorAll("[data-opt]:checked"), function (r) { return r.value; });
    }
    function update() {
      var sel = selected(),
          v = data.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = btn.dataset.unavailable || "Unavailable"; }
        return;
      }
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.innerHTML = fmt(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.dataset.add || "Add to cart") : (btn.dataset.soldout || "Sold out");
      }
      if (stockEl) {
        stockEl.className = "stock";
        if (!v.available) { stockEl.classList.add("stock--out"); stockEl.textContent = stockEl.dataset.out || "Out of stock"; }
        else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
          stockEl.classList.add("stock--low");
          stockEl.textContent = (stockEl.dataset.low || "Only [count] left").replace("[count]", v.inventory_quantity);
        } else { stockEl.textContent = stockEl.dataset.in || "In stock"; }
      }
      if (history.replaceState && v.id) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }
    form.querySelectorAll("[data-opt]").forEach(function (r) { r.addEventListener("change", update); });
    update();
  });

  /* GA4 / Meta ecommerce events — fires only if a tag is present */
  window.dataLayer = window.dataLayer || [];
  function push(name, params) { window.dataLayer.push(Object.assign({ event: name }, params || {})); }
  var vi = document.querySelector("[data-view-item]");
  if (vi) { try { push("view_item", JSON.parse(vi.textContent)); } catch (e) {} }
  document.querySelectorAll("[data-add]").forEach(function (b) {
    b.addEventListener("click", function () {
      var f = b.closest("form"), n = f && f.querySelector("[data-item-payload]");
      if (n) { try { push("add_to_cart", JSON.parse(n.textContent)); } catch (e) {} }
    });
  });
  document.querySelectorAll("[data-begin-checkout]").forEach(function (b) {
    b.addEventListener("click", function () { push("begin_checkout", {}); });
  });
})();
